import { graphql } from "~/gql";

export const FIND_RELEVANT_EXTERNAL_MATTERS_QUERY = graphql(/* GraphQL */ `
  query FindRelevantExternalMatters(
    $text: String!
    $clientName: String!
    $filter: RelevantExternalMattersFilter
    $fetchAccruedFees: Boolean
    $unlinkedOnly: Boolean
    $distanceThreshold: Float = 2
    $maxResults: Int = 50
    $additionalSearchText: String
  ) {
    findRelevantExternalMatters(
      text: $text
      clientName: $clientName
      filter: $filter
      fetchAccruedFees: $fetchAccruedFees
      unlinkedOnly: $unlinkedOnly
      distanceThreshold: $distanceThreshold
      maxResults: $maxResults
      additionalSearchText: $additionalSearchText
    ) {
      externalMatters {
        relevanceScore
        id
        title
        externalCreatedAt
        currency {
          id
          code
        }
        organisationalUnit {
          id
          name
        }
        externalReference
        status
        taxStatus
        leadFeeEarner {
          id
          name
        }
        client {
          id
          name
        }
      }
      accruedFees {
        clientName
        actualFee
        actualGpm
        amountBilled
        amountPaid
        externalMatterId
        matterTitle
        accruedTimes {
          feeEarnerId
          actualDuration
          actualDurationSinceLastInvoice
          actualFee
          actualFeeSinceLastInvoice
          actualCost
          actualCostSinceLastInvoice
          currencySymbol
          feeEarnerLevelDescription
          feeEarnerName
        }
        currencySymbol
        invoices {
          id
          description
          status
          totalFeeNet
          date
        }
      }
    }
  }
`);
